export enum ROUTES {
  HOME = '/',
  AI_BOT_CONFIGURATION = '/ai-bot-configuration',
  GENERAL_SETTINGS = '/general-settings',
  UI_SETTINGS = '/ui-settings',
  SHIPPING_PRICES = '/shipping-prices',
  COUPONS = '/coupons',
  DELIVERY_SETTINGS = '/delivery-settings',
  PAYMENT_METHODS = '/payment-methods',
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up',
  PAGES_MANAGEMENT = '/pages-management',
  REVIEWS = '/reviews',
  SEO = '/seo',
  BRANDS = '/brands',
  SITE_MAP = '/site-map',
  CHANNELS = '/channels',
  NOT_FOUND = '*',
  REDIRECTS = '/redirects',
  LLM_CONFIG = '/llm-config',
  LLM_CHANNEL_TEMPLATE = '/llm-channel-template',
  LLM_TEMPLATES = '/llm-templates',
  LLM_TEMPLATE_DETAILS = '/llm-templates/:channelType',
  AKENEO_PRODUCTS = '/aekeneo-products',
  CLEAN_UP_DATABASE = '/clean-up-database',
  PRODUCTS_SYNC = '/products-sync',
  LINKING_TOOL = '/linking-tool',
  MERCHANT_SETTINGS = '/merchant-settings',
  METATAGS_TEMPLATES = '/metatags-templates',
  ROBOTS_TXT = '/robots-txt',
  VARIABLES = '/variables',
  FAQS = '/faqs',
  GENERAL_FAQS = '/general-faqs',
  SUGGESTED_FAQS = '/suggested-faqs',
  SUGGESTED_FAQ_DETAILS = '/suggested-faqs/:id',
  CONVERSATIONS = '/conversations',
  CONVERSATION_DETAILS = '/conversations/:id',
  CATEGORIES = '/categories',
  AKENEO = '/akeneo',
  BLOG = '/blog',
  WEBSITES = '/websites',
  PUSH_ORDERS = '/push-orders',
}
